// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3EepH","withHeader":"styles_withHeader__2ePKH","side":"styles_side__3W6NP"};